<template>
  <router-link
    :to="{
      name: 'retainers.overview',
      params: { retainer_id: retainer.id },
    }"
  >
    <div class="row">
      <div class="col-12 col-lg-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Client:</span>
          <span class="strong">{{ retainer.client.company }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-3 col-xl-3">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Amount:</span>
          ${{ retainer.amount | currency }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Start:</span>
          {{ retainer.start | moment("DD/MM/YYYY") }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">End:</span>
          {{ retainer.end ? $options.filters.moment(retainer.end, "DD/MM/YYYY") : 'Ongoing' }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    retainer: {
      required: true,
      type: Object,
    },
  }
};
</script>
